import React from "react";

import { Container, Row, Col, Alert } from "reactstrap";

const IntakeFormSuccess = () => {
	return (
		<Container>
			<Row className="mt-4">
				<Col>
					<h3>California Consumer Privacy Act Request</h3>
				</Col>
			</Row>
			<Row>
				<Col>
					<Alert color="success">We have received your CCPA request.</Alert>
					<p className="mt-4">
						Thank you for your California Consumer Privacy Act (CCPA) request.
						You will receive an email confirming receipt of your request
						shortly.
					</p>
				</Col>
			</Row>
			<Row>
				<Col className="text-center">
					<a
						href="https://www.troweprice.com/privacy"
						className="btn btn-primary app-link-button"
					>
						Return to Privacy Policy
					</a>
				</Col>
			</Row>
		</Container>
	);
};

export default IntakeFormSuccess;
